import { ExperiencePageTargetingFe } from "@intelligems/ig-types";

export interface IPageTargetingState {
  isSuccess: boolean;
  pageTargeting: ExperiencePageTargetingFe[];
  storedPageTargeting: ExperiencePageTargetingFe[];
}

export const initialIPageTargetingState: IPageTargetingState = {
  isSuccess: false,
  pageTargeting: [],
  storedPageTargeting: [],
};
